<template>
  <section
    v-if="value !== null"
    class="data mb10"
  >
    <div :id="targetId">
      <p
        class="h-style-02"
        :class="titleClass"
      >
        {{ title }}
      </p>
      <job-preview-content-data-tooltip />
      <div class="container bar-graph fwB mt20">
        <div>
          <div class="graph">
            <div
              class="bar"
              :style="`height: ${averageHight}px; margin-top: ${graphHight-averageHight}px;`"
              data-test="average"
            >
              <p><span>{{ averageValue }}</span><span>{{ unit }}</span></p>
            </div>
            <div
              class="bar this"
              :style="`height: ${thisHight}px; margin-top: ${graphHight-thisHight}px;`"
            >
              <p><span>{{ value }}</span><span>{{ unit }}</span></p>
            </div>
          </div>
          <div class="label-horizontal">
            <div class="user-label">
              全国平均
            </div>
            <div class="user-label">
              当社
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewContentDataTooltip from '@/components/atoms/JobPreviewContentDataTooltip'
import jobPreviewGraph from '@/lib/jobPreviewGraph'

export default {
  components: {
    JobPreviewContentDataTooltip
  },
  mixins: [jobPreviewGraph],
  props: {
    targetId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      default: null
    },
    averageValue: {
      type: Number,
      default: null
    },
    unit: {
      type: String,
      required: true
    },
    titleClass: {
      type: String,
      default: ''
    }
  }
}
</script>
